<template>
  <div class="container main-content article-content">
    <div class="section--profile-awards">
      <span class="title">Go for it</span>
      <div class="row">
        <div class="award-box">
          <div class="award-box-image">
            <img src="../../assets/images/badge-1.svg">
          </div>
          <span class="award-box-title">New joiner</span>
          <span class="award-box-info">4 of 5 recruitment tasks finished</span>
        </div>
        <div class="award-box">
          <div class="award-box-image">
            <img src="../../assets/images/badge-2.svg">
          </div>
          <span class="award-box-title">Uncognito</span>
          <span class="award-box-info">2 of 8 basic  information filled</span>
        </div>
      </div>

      <span class="title">Received awards</span>
      <div class="row">
        <div class="award-box">
          <div class="award-box-image">
            <img src="../../assets/images/badge-3.svg">
          </div>
          <span class="award-box-title">Comment Veteran</span>
          <span class="award-box-info">100 of 100 comments  are published</span>
        </div>
        <div class="award-box">
          <div class="award-box-image">
            <img src="../../assets/images/badge-4.svg">
          </div>
          <span class="award-box-title">Approved</span>
          <span class="award-box-info">Your profile is approved</span>
        </div>
        <div class="award-box">
          <div class="award-box-image">
            <img src="../../assets/images/badge-5.svg">
          </div>
          <span class="award-box-title">New joiner</span>
          <span class="award-box-info">100 of 100 likes gived away</span>
        </div>
      </div>

      <span class="title">Awards</span>
      <div class="row">
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
        <div class="award-box empty">
          <div class="award-box-image"></div>
          <span class="award-box-title">Lorem ipsum</span>
          <span class="award-box-info">0 of 10 lorem ipsumes are completed</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfileAwards"
}
</script>

<style scoped>

</style>
